module.exports = __webpack_public_path__ + "img/hx_5.c1f43b22.jpg";